/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { createSlice } from "@reduxjs/toolkit";
import { Tenant, TenantState } from "../../models";
import {
  createTenantDetails,
  deleteTenant,
  editTenantDetails,
  getAvailableCurrencies,
  getAvailableDataCenters,
  getAvailableProducts,
  getAvailableTimeZones,
  getTenantExportList,
  getTenantList,
  getTenantLogo,
  uploadTenantLogoDetails,
  getAvailableCountries,
  getAvailableRegions,
  fetchFilterCounts,
  getForgeCustomeIdTenantData,
  getGeoMapping,
} from "./tenant-actions";

const initialSliceState: TenantState = {
  tenants: [],
  totalQuantity: 0,

  availableTimeZones: [],
  availableCurrencies: [],
  availableProducts: [],
  availableDataCentres: [],
  tenantEdited: false,

  /// Tenant List Slice:
  filterTenants: [],
  applicationstoFilterTenants: [],
  filterApp: [],
  filterRegion: [],
  hasError: false,
  errorCode: null,
  exportedData: [],
  availableCountries: [],
  availableRegions: [],
  filterData: {},
  filteredjson: {
    assignedApps: [],
    region: [],
  },
  forgeCustomerTenantData: {
    id: "",
    tenantName: "",
    forgeCustomerId: "",
    timezone: "",
    datacenter: "",
    currency: "",
    lastUpdatedTimeStamp: "",
    region: 0,
    country: 0,
    zipcode: 0,
    createdon: "",
  },
  currentTenantIdOfLoadedUsers: "",
  geoMapping: { regionDataMap: [], countryDataMap: [] },
};

const tenantSlice = createSlice({
  name: "tenant",
  initialState: initialSliceState,

  extraReducers(builder) {
    builder
      .addCase(getAvailableDataCenters.fulfilled, (state, action: any) => {
        state.availableDataCentres = action.payload.data;
      })
      .addCase(getAvailableDataCenters.rejected, (state, action) => {})
      .addCase(getAvailableDataCenters.pending, (state) => {});

    // get geomapping
    builder
      .addCase(getGeoMapping.fulfilled, (state, action: any) => {
        state.geoMapping = action.payload.data;
      })
      .addCase(getGeoMapping.rejected, (state, action) => {})
      .addCase(getGeoMapping.pending, (state) => {});

    /// get available timezones
    builder
      .addCase(getAvailableTimeZones.fulfilled, (state, action: any) => {
        state.availableTimeZones = action.payload.data;
      })
      .addCase(getAvailableTimeZones.rejected, (state, action) => {})
      .addCase(getAvailableTimeZones.pending, (state) => {});

    /// get available currencies
    builder
      .addCase(getAvailableCurrencies.fulfilled, (state, action: any) => {
        state.availableCurrencies = action.payload.data;
      })
      .addCase(getAvailableCurrencies.rejected, (state, action) => {})
      .addCase(getAvailableCurrencies.pending, (state) => {});

    /// get available products
    builder
      .addCase(getAvailableProducts.fulfilled, (state, action: any) => {
        state.availableProducts = action.payload.data;
      })
      .addCase(getAvailableProducts.rejected, (state, action) => {})
      .addCase(getAvailableProducts.pending, (state) => {});

    // get tenants
    builder
      .addCase(getTenantList.fulfilled, (state, action: any) => {
        state.tenants = action.payload.tenants;
        state.totalQuantity = action.payload.totalCount;
      })
      .addCase(getTenantList.rejected, (state, action) => {})
      .addCase(getTenantList.pending, (state) => {});

    // get  Tenant Exported List
    builder
      .addCase(getTenantExportList.fulfilled, (state, action: any) => {
        state.exportedData = action.payload;
      })
      .addCase(getTenantExportList.rejected, (state, action) => {})
      .addCase(getTenantExportList.pending, (state) => {});

    // get filter Count
    builder
      .addCase(fetchFilterCounts.fulfilled, (state, action: any) => {
        state.filterData = action.payload;
      })
      .addCase(fetchFilterCounts.rejected, (state, action) => {})
      .addCase(fetchFilterCounts.pending, (state) => {});

    // delete tenant
    builder
      .addCase(deleteTenant.fulfilled, (state, action: any) => {
        state.tenants = state.tenants.filter((x) => x.id != action.payload);
      })
      .addCase(deleteTenant.rejected, (state, action) => {})
      .addCase(deleteTenant.pending, (state) => {});
    // Create Tenant
    builder
      .addCase(createTenantDetails.fulfilled, (state, action: any) => {
        /// Add the tenant to the list
        state.tenants.push(action.payload);
      })
      .addCase(createTenantDetails.rejected, (state, action) => {})
      .addCase(createTenantDetails.pending, (state) => {});
    // End create tenant
    // Edit tenant
    builder
      .addCase(editTenantDetails.fulfilled, (state, action: any) => {
        const tenanttoUpdate = state.tenants.find(
          (x) => x.id === action.payload.id
        );
        Object.assign(tenanttoUpdate as Tenant, action.payload as Tenant);
        state.tenants = [...state.tenants];
      })
      .addCase(editTenantDetails.rejected, (state, action) => {})
      .addCase(editTenantDetails.pending, (state) => {});
    // End edit tenant
    /// Update logo
    builder
      .addCase(uploadTenantLogoDetails.fulfilled, (state, action: any) => {})
      .addCase(uploadTenantLogoDetails.rejected, (state, action) => {})
      .addCase(uploadTenantLogoDetails.pending, (state) => {});
    /// End update logo

    //Get Logo
    builder
      .addCase(getTenantLogo.fulfilled, (state, action: any) => {
      })
      .addCase(getTenantLogo.rejected, (state, action) => {})
      .addCase(getTenantLogo.pending, (state) => {});
    //Update Logo
    //Fetch Regions
    builder
      .addCase(getAvailableRegions.fulfilled, (state, action: any) => {
        state.availableRegions = action.payload.data;
      })
      .addCase(getAvailableRegions.rejected, (state, action) => {})
      .addCase(getAvailableRegions.pending, (state) => {});
    //Fetch Countries
    builder
      .addCase(getAvailableCountries.fulfilled, (state, action: any) => {
        state.availableCountries = action.payload.data;
      })
      .addCase(getAvailableCountries.rejected, (state, action) => {})
      .addCase(getAvailableCountries.pending, (state) => {});

    //Fetch Tenant Data for logged in Tenant Admin user
    builder
      .addCase(getForgeCustomeIdTenantData.fulfilled, (state, action: any) => {
        state.forgeCustomerTenantData = action.payload.data;
      })
      .addCase(getForgeCustomeIdTenantData.rejected, (state, action) => {})
      .addCase(getForgeCustomeIdTenantData.pending, (state) => {});
  },
  reducers: {
    tenantEdited(
      state: TenantState,
      action: {
        payload: boolean;
      }
    ) {
      state.tenantEdited = action.payload;
    },
    /// Tenant List slice:
    createfilteredList(state, action) {
      state.filterTenants = action.payload;
    },

    showTenantList(state, action) {
      state.tenants = action.payload;
      state.filterTenants = action.payload;
    },
    showFilteredList(state, action) {
      state.applicationstoFilterTenants = action.payload;
    },

    showExportedData(state, action) {
      state.exportedData = action.payload;
    },
    filterusingselectedApplication(state, action) {
      state.filterApp = action.payload;
    },
    filterusingselectedLocation(state, action) {
      state.filterRegion = action.payload;
    },
    filerTenantsBasedOnSearchText(state, action) {
      let searchText = action.payload;
      let searchedTenants = state.tenants.filter(
        (x: any) =>
          (x.tenantName as string)
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          ((x as any).addressLine1 as string)
            .toLowerCase()
            .includes(searchText.toLowerCase())
      );
      state.filterTenants = searchedTenants;
      if (
        searchedTenants === null ||
        searchedTenants.length === 0 ||
        searchedTenants === undefined
      ) {
        state.hasError = false;
        state.errorCode = null;
      }
    },

    gettenantLogo(state, action) {
      state.tenantLogo = action.payload;
    },
    gettenantbyID(
      state,
      action: {
        payload: string;
      }
    ) {
      state.currentTenantID = action.payload;
    },

    resetErrorAsItsAlreadyDisplayed(state) {
      state.errorCode = null;
      state.hasError = false;
    },

    getCurrentTenantIdOfLoadedUsers(state, action) {
      state.currentTenantIdOfLoadedUsers = action.payload;
    },
  },
});

export const tenantActions = tenantSlice.actions;

export default tenantSlice;
